import appApis from "@/services/module/app";
import userApis from "@/services/module/influencer";
import selectionApis from "@/services/module/selection";
import selectionCalendarApis from "@/services/module/selectionCalendar";
import sourceApis from "@/services/module/source";
import specialApis from "@/services/module/special";
import specialEventConfigurationApis from "@/services/module/specialEventConfiguration";
import { exportApis } from "@/services/module/export";
import wxAccountApis from "@/services/module/wxAccount";
import materialsApis from "@/services/module/materials";
import popupApis from "@/services/module/popup";
import qunjielongAccountApis from "@/services/module/qunjielongAccount";
import copywritingAgentApis from "@/services/module/copywritingAgent";
import copywritingApis from "@/services/module/copywriting";
import copywritingStyleApis from "@/services/module/copywritingStyle";
import complianceWordbookApis from "@/services/module/complianceWordbook";
import externalMaterialApis from "@/services/module/externalMaterial";
import adminUserApis from "@/services/module/adminUser";
import authApis from "@/services/module/auth";
import sampleManageApis from "@/services/module/sampleManage";
import memberOrderApis from "@/services/module/memberOrder";
import cuecardApis from "@/services/module/cuecard";

const apis = {
  app: appApis,
  selectionCalendar: selectionCalendarApis,
  special: specialApis,
  specialEventConfiguration: specialEventConfigurationApis,
  selection: selectionApis,
  user: userApis,
  source: sourceApis,
  wxAccount: wxAccountApis,
  export: exportApis,
  materials: materialsApis,
  popup: popupApis,
  qunjielongAccount: qunjielongAccountApis,
  copywritingAgent: copywritingAgentApis,
  copywriting: copywritingApis,
  copywritingStyle: copywritingStyleApis,
  complianceWordbook: complianceWordbookApis,
  externalMaterial: externalMaterialApis,
  adminUser: adminUserApis,
  auth: authApis,
  sampleManage: sampleManageApis,
  memberOrder: memberOrderApis,
  cuecard: cuecardApis,
};

export default apis;
